















































































































































































































































































































import ButtonTrusteeSendEmail from "@/components/ButtonTrusteeSendEmail.vue";
import ConfirmationModal from "@/components/ConfirmationModal.vue";
import DatePicker from "vue2-datepicker";
import Question from "@/components/Question.vue";
import Results from "@/components/Results.vue";
import Slider from "vue-slider-component";
import Spinner from "vue-simple-spinner";
import Voters from "@/components/Voters.vue";
import _ from "lodash";
import assert from "assert";
import draggable from "vuedraggable";
import { Column, Election, State, Trustee, Uuid, Voter, Vue } from "@/types.ts";
import { Store } from "vuex";
import { VueGoodTable } from "vue-good-table";

async function push(
  store: Store<State>,
  election: Election,
  trustees: Array<Trustee>
) {
  const patch = _.cloneDeep(election);
  delete patch.externalTrustees;
  delete patch.voters;
  store.dispatch("updateElection", patch);
  if (trustees) await store.dispatch("addTrustees", { election, trustees });
}

const pushDebounced = _.debounce(push, 5000);

async function updateVoters(
  store: Store<State>,
  election: Election
): Promise<void> {
  return store.dispatch("setVoters", {
    election: election,
    voters: election.voters,
  });
}

const updateVotersDebounced = _.debounce(updateVoters, 2000);

export default Vue.extend({
  name: "Election",
  components: {
    draggable,
    ButtonTrusteeSendEmail,
    DatePicker,
    Question,
    Results,
    Slider,
    Spinner,
    Voters,
    Vuetable: VueGoodTable,
  },
  computed: {
    columnsAddVoters(): Array<Column> {
      if (this.newVoters) return this.columnsOfVoters(this.newVoters);
      else return [];
    },
    editableSuper(): boolean {
      assert(this.election);
      return !this.election.published && this.superuser;
    },
    elections(): Map<string, Election> | null {
      const state = this.$store.state;
      assert(state.electionsTracker);
      return state.elections;
    },
    otherElections(): Array<Election> | null {
      const { election, elections } = this;
      if (!election || !elections) return null;
      return _.filter(
        Array.from(elections.values()),
        e => e.uuid !== election.uuid
      );
    },
    publishError(): string | null {
      if (!this.election?.name) return "Le nom du scrutin est vide.";
      if (!this.election?.description)
        return "La description du scrutin est vide.";
      if (this.election?.questions.length == 0)
        return "Le scrutin n'a pas de question.";
      if (this.election?.questions.find(q => q.question === ""))
        return "L'intitulé de certaines questions est vide.";
      if (this.election?.questions.find(q => q.answers.length == 0))
        return "Certaines questions n'ont pas de réponse.";
      if (
        this.election?.questions.find(q => q.answers.find(a => a === "") === "")
      )
        return "Certaines réponses n'ont pas d'intitulé.";
      if (this.election?.voters.length == 0)
        return "Le scrutin n'a pas de votants.";
      if (!this.election?.trusteesSealed)
        return "La configuration des scrutateurs n'est pas scellée.";
      if (
        this.election?.externalTrustees?.find(
          t => !t.credentials || (t.threshold && !t.voutput)
        )
      )
        return "Certains scrutateurs n'ont pas généré leur clé.";
      return null;
    },
    superuser(): boolean {
      return this.$store.state.administrators !== null;
    },
    trustees(): Array<Trustee> {
      assert(this.election);
      return this.election.externalTrustees || [];
    },
    trusteesColumns(): Array<Column> {
      return [
        {
          label: "Courriel",
          field: "email",
        },
        {
          label: "Statut",
          field: "status",
        },
        {
          label: "Envoyer",
          field: "send-email",
        },
        {
          label: "Lien",
          field: "link",
        },
      ];
    },
    trusteesError(): string | null {
      const trustees = this.election!.externalTrustees;
      const invalid = _.find(
        trustees,
        trustee => trustee.email.indexOf("@") === -1
      );
      if (invalid) return `invalid trustee email: ${invalid.email}`;
      else return null;
    },
    voters(): Array<Voter> | null {
      const election = this.election;
      if (!election) return null;
      return election.voters;
    },
    tally() {
      if (!this.election?.tally) return null;
      const tally = JSON.parse(this.election.tally);
      return {
        count: tally.num_tallied,
        results: tally.result,
      };
    },
  },
  data: () => {
    return {
      copyFrom: null as null | Uuid,
      dropping: false,
      election: undefined as Election | null | undefined,
      loaded: false,
      newVoters: null as null | Array<Voter>,
    };
  },
  methods: {
    addQuestion(): void {
      this.election?.questions.push({
        answers: [],
        min: 0,
        max: 1,
        question: "",
        blank: false,
      });
      this.push();
    },
    addTrustee(): void {
      assert(this.election);
      const email = window.prompt("Courriel du scrutateur");
      if (email == null || email == "") return;
      const trustee = { email, threshold: false };
      if (this.election.externalTrustees === undefined)
        this.$set(this.election, "externalTrustees", [trustee]);
      else this.election.externalTrustees.push(trustee);
      this.election.threshold += 1;
      pushDebounced(this.$store, this.election, [trustee]);
      pushDebounced.flush();
    },
    sealTrustees(): void {
      assert(this.election);
      this.$set(this.election, "trusteesSealed", true);
      this.flush();
    },
    async setVoters(): Promise<void> {
      assert(this.election);
      const voters = this.newVoters;
      this.newVoters = null;
      return this.$store.dispatch("setVoters", {
        election: this.election,
        voters,
      });
    },
    updateVoters(): void {
      assert(this.election);
      updateVotersDebounced(this.$store, this.election);
    },
    back() {
      this.$router.push({ name: "Admin" });
    },
    columnsOfVoters(voters: Array<Voter>) {
      const columns: Array<Column> = [
        {
          label: "Nom",
          field: "name",
        },
        {
          label: "Courriel",
          field: "email",
        },
        {
          label: "Votes",
          field: "votes",
          type: "number",
        },
      ];
      if (_.find(voters, voter => voter.code) !== undefined)
        columns.push({ label: "Code", field: "code" });
      if (_.find(voters, voter => voter.data) !== undefined)
        columns.push({ label: "Donnée Personnelle", field: "data" });
      if (_.find(voters, voter => voter.phone) !== undefined)
        columns.push({ label: "Téléphone", field: "phone" });
      if (this.election?.published && !this.election?.tally) {
        columns.push({
          label: "Isoloir",
          field: "booth",
          sortable: false,
        });
        if (this.superuser)
          columns.push({
            label: "Clé",
            field: "key",
            sortable: false,
          });
        columns.push({
          label: "Envoyer",
          field: "send-email",
          sortable: false,
        });
      }
      return columns;
    },
    async copyVoters() {
      assert(this.copyFrom);
      assert(this.election);
      const voters = await this.$store.dispatch("copyVoters", {
        from: this.copyFrom,
        to: this.election.uuid,
      });
      this.election.voters = voters;
    },
    deleteModal() {
      this.$modal.show(ConfirmationModal, {
        action: this.delete,
        description:
          "Êtes vous sûr de vouloir supprimer définitivement le scrutin ? Cette opération est irréversible.",
        title: "Suppression du scrutin",
        verb: "Supprimer",
      });
    },
    async delete() {
      this.hideModal();
      await this.$store.dispatch("electionDelete", { election: this.election });
      this.back();
    },
    dragover(event: DragEvent) {
      event.preventDefault();
      this.dropping = true;
    },
    dragleave(event: DragEvent) {
      event.preventDefault();
      this.dropping = false;
    },
    async drop(event: DragEvent) {
      event.preventDefault();
      this.dropping = false;
      if (event.dataTransfer?.files?.length) {
        const file = event.dataTransfer?.files[0];
        const reader = new FileReader();
        await new Promise(resolve => {
          reader.onloadend = resolve;
          reader.readAsText(file, "ISO-8859-1");
        });
        assert(typeof reader.result === "string");
        const content: string = reader.result;
        let sep = ";";
        this.newVoters = [];
        const marks = new Set();
        let maybeHeader = true;
        _.forEach(content.split(/\r?\n/), (line, lineNumber) => {
          try {
            if (line === "") return;
            else if (line.startsWith("sep=")) {
              sep = line.replace(/^sep=/, "");
              return;
            }
            const chunks = line.split(sep);
            if (chunks.length < 2)
              throw Error(
                `nombre de colones insuffisant en ligne ${lineNumber}`
              );
            const email = chunks[1];
            if (marks.has(email)) throw Error(`email en doublon: ${email}`);
            else marks.add(email);
            const votes = (() => {
              if (chunks.length >= 3) {
                const votes = parseInt(chunks[2]);
                if (isNaN(votes))
                  throw Error(
                    `nombre de voix invalide pour ${email}: ${chunks[2]}`
                  );
                return votes;
              } else return 1;
            })();
            maybeHeader = false;
            this.newVoters?.push({
              code: chunks[3] || undefined,
              data: chunks[4] || undefined,
              email,
              name: chunks[0],
              phone: chunks[5] || undefined,
              votes,
            });
          } catch (e) {
            if (maybeHeader) maybeHeader = false;
            else {
              this.newVoters = null;
              alert(`Fichier votant invalide: ${e.message}`);
            }
            return;
          }
        });
      }
    },
    openTrustee(trustee: Trustee) {
      assert(this.election);
      return {
        name: "Trustee",
        params: { uuid: this.election.uuid, email: trustee.email },
        query: { code: trustee.code },
      };
    },
    loadElection(): void {
      pushDebounced.flush();
      updateVotersDebounced.flush();
      const elections = this.$store.state.elections;
      if (!elections) this.election = undefined;
      else {
        this.election = _.cloneDeep(elections.get(this.uuid) || null);
      }
    },
    async publish(): Promise<void> {
      assert(this.election);
      this.election.published = true;
      this.flush();
    },
    push(): void {
      const election = this.election;
      assert(election);
      const original = this.elections?.get(this.uuid);
      assert(original);
      const threshold =
        election.threshold < (election.externalTrustees?.length || 0);
      const trustees = _(election.externalTrustees)
        .map(trustee => ({ ...trustee, threshold }))
        .filter(trustee => {
          const t = original.externalTrustees?.find(
            t => t.email === trustee.email
          );
          return !_.isEqual(t, trustee);
        })
        .value();
      pushDebounced(this.$store, election, trustees);
    },
    flush(): void {
      this.push();
      pushDebounced.flush();
      updateVotersDebounced.flush();
    },
    removeQuestion(i: number): void {
      this.election?.questions.splice(i, 1);
    },
    removeTrustee(trustee: Trustee): void {
      this.$store.dispatch("removeTrustee", {
        election: this.election,
        trustee,
      });
    },
    async tallyElection(): Promise<void> {
      this.hideModal();
      await this.$store.dispatch("tally", {
        election: this.election,
      });
    },
    showTallyModal() {
      this.$modal.show(ConfirmationModal, {
        action: this.tallyElection,
        description:
          "Êtes vous sûr de vouloir dépouiller le scrutin ? Cette opération est irréversible et aucun vote ne pourra plus être soumis.",
        title: "Dépouillage du scrutin",
        verb: "Dépouiller",
      });
    },
    hideModal() {
      this.$modal.hide("confirm");
    },
  },
  mounted(): void {
    this.$store
      .dispatch("loadElection", {
        uuid: this.uuid,
      })
      .then(() => {
        this.loaded = true;
      });
  },
  props: {
    uuid: { type: String, required: true },
  },
  // Hooks
  beforeRouteEnter(to, from, next) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    next((self: any) => self.loadElection());
  },
  beforeRouteUpdate() {
    this.loadElection();
  },
  beforeRouteLeave(to, from, next) {
    pushDebounced.flush();
    updateVotersDebounced.flush();
    next();
  },
  watch: {
    elections: {
      handler() {
        this.loadElection();
      },
      immediate: true,
    },
  },
});
